import React from 'react';
import Context from '../../contexts/MarketPerformanceContext';
import MarketGroups from '../MarketGroups/MarketGroups';
import InstrumentPerformance from '../InstrumentPerformance/InstrumentPerformance';

class MarketPerformance extends InstrumentPerformance {
    getDataParams = () => {
        const { currentTabId, currentChartRangeId, currentIndexId } = this.state;

        return {
            currentTabId,
            currentChartRangeId,
            currentIndexId,
        };
    };

    getFullInstruments = (marketGroup) => {
        this.setState(
            {
                loading: true,
                currentView: 'FullInstruments',
            },
            () => this.fetchFullInstruments(marketGroup),
        );
    };

    fetchFullInstruments = (marketGroup) => {
        const url = `${window.location.href.replace(/\/$/, '')}/state/instruments?marketGroupId=${marketGroup}`;
        return this.fetchData(url);
    };

    render = () => (
        <Context.Provider value={{
            state: this.state,
            setCurrentTab: this.setCurrentTab,
            setCurrentIndex: this.setCurrentIndex,
            setCurrentChartRange: this.setCurrentChartRange,
            getFullIndices: this.getFullIndices,
            getFullInstruments: this.getFullInstruments,
            backToOverview: this.backToOverview,
        }}>
            <MarketGroups/>
        </Context.Provider>
    );
}

export default MarketPerformance;
